// extracted by mini-css-extract-plugin
module.exports = {"drag_container":"DragContainer_drag_container__QNxMR"};